import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ScenariosService from "@services/ScenariosService";

export const getEditScenario = createAsyncThunk(
  "scenario/edit",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await ScenariosService.viewScenario({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const updateScenario = createAsyncThunk(
  "scenario/update",
  async ({id, scenario}, {rejectWithValue}) => {
    try {
      const response = await ScenariosService.updateScenario({id, scenario});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  target: null,
  initialTarget: null,
  isChanged: false,
  errors: null,
  error: "",
  status: "",
};

const editScenarioSlice = createSlice({
  name: "edit-scenario",
  initialState,
  reducers: {
    setTarget(state, action) {
      state.target = action.payload;
    },
    patchTarget(state, action) {
      if (!state.target) {
        return;
      }

      state.target = {
        ...state.target,
        ...action.payload,
      };
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearEdit() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEditScenario.pending, (state) => {
        pendingState(state);
      })
      .addCase(getEditScenario.fulfilled, (state, action) => {
        state.target = {
          ...action.payload,
          products: action.payload?.products || [],
        };
        state.initialTarget = {
          ...action.payload,
          products: action.payload?.products || [],
        };
        fulfilledState(state);
      })
      .addCase(getEditScenario.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(updateScenario.pending, (state) => {
        pendingState(state);
      })
      .addCase(updateScenario.fulfilled, (state, action) => {
        if (action.payload) {
          state.target = {
            ...action.payload,
            products: action.payload?.products || state.target?.products || [],
          };
          state.initialTarget = {
            ...action.payload,
            products: action.payload?.products || state.target?.products || [],
          };
        }
        fulfilledState(state);
      })
      .addCase(updateScenario.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {setIsChanged, setTarget, patchTarget, setError, setStatus, clearEdit} =
  editScenarioSlice.actions;
export default editScenarioSlice.reducer;
